import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService{
  constructor() {}

  public addLoader() {
    window.scrollTo(0, 0);
    const loader= window.document.getElementById("loader-background");
    const body = document.body;
    if (!body.classList.contains("no-scroll") && loader) {
      loader.classList.remove("d-none");
      body.classList.add("no-scroll");
      loader.classList.add("d-flex");
    }
  }

  public removeLoader() {
    const loader= window.document.getElementById("loader-background");
    const body = document.body;
    if(body.classList.contains("no-scroll") && loader) {
      body.classList.remove("no-scroll");
      loader.classList.remove("d-flex");
      loader.classList.add("d-none");
    }
  }
}
